export default "__VITE_ASSET__480d34ac__"